import { translate } from "app/language/service"
import { IDsp } from "dsp/model"
import { searchDspByNameInStore } from "dsp/tools/common"
import React from "react"
import { EntitySelect } from "ui/components/EntitySelect"

interface IDspSingleSelectProps {
  id?: string
  disabled?: boolean
  required?: boolean
  error?: string
  defaultSelectedDspId?: number | null
  sx?: any
  onChange: (dsp: IDsp | undefined) => any
  onBlur?: () => any
}

export const DspSingleSelect = React.memo(
  ({
    id,
    defaultSelectedDspId,
    disabled,
    required,
    error,
    sx,
    onChange,
    onBlur
  }: IDspSingleSelectProps): JSX.Element => (
    <EntitySelect
      id={id || "dsp-single-select"}
      required={required}
      disabled={disabled}
      defaultSelectedEntityId={defaultSelectedDspId}
      minFilterLength={1}
      searchOnEmptyFilter
      inputLabel={translate("dsp.title")}
      error={error}
      onBlur={onBlur}
      sx={sx}
      inputPlaceholder={translate("label.search.name")}
      getOptionLabel={(dsp: any) => dsp.name || "-"}
      onChange={(dsp: any | null) => onChange(dsp || undefined)}
      searchEntities={filter => Promise.resolve(searchDspByNameInStore(filter))}
    />
  )
)
